const navigation = {
  header: [
    {
      label: "Products",
      children: [
        { label: "All products", href: "/our-products" },
        { label: "Vaults", href: "/vaults" },
        { label: "DocIQ", href: "/dociq" },
        { label: "Flows", href: "/flows" },
        { label: "Client Portal", href: "/client-portal" },
      ],
    },
    { label: "Pricing", href: "/pricing" },
    { label: "Security", href: "/security" },
    {
      label: "Resources",
      children: [
        { label: "Blog", href: "/blog/" },
        { label: "FAQ", href: "/faq" },
      ],
    },
    {
      label: "Company",
      children: [
        { label: "About", href: "/about" },
        { label: "Team", href: "/team" },
        { label: "Contact Us", href: "/contact-us" },
      ],
    },
  ],
  actions: [
    {
      label: "Login",
      children: [
        { label: "Individual Login", hrefKey: "login", description: "Personal vault access" },
        { label: "Provider Login", hrefKey: "providerLogin", description: "For approved providers" },
      ],
    },
    { label: "Get Started", hrefKey: "getStarted" },
    { label: "For Providers", href: "/providers" },
  ],
  footer: [
    {
      label: "Products",
      children: [
        { label: "All products", href: "/our-products" },
        { label: "Vaults", href: "/vaults" },
        { label: "DocIQ", href: "/dociq" },
        { label: "Flows", href: "/flows" },
        { label: "Client Portal", href: "/client-portal" },
        { label: "For Providers", href: "/providers" },
        { label: "Pricing", href: "/pricing" },
      ],
    },
    {
      label: "Company",
      children: [
        { label: "About", href: "/about" },
        { label: "Team", href: "/team" },
        { label: "Security", href: "/security" },
        { label: "Contact Us", href: "/contact-us" },
        { label: "Schedule Demo", href: "/schedule-demo" },
      ],
    },
    {
      label: "Resources",
      children: [
        { label: "Blog", href: "/blog/" },
        { label: "FAQ", href: "/faq" },
      ],
    },
    {
      label: "AmitaSoft",
      children: [
        { label: "About AmitaSoft", href: "https://amitasoft.com/" },
        { label: "CliQloan", href: "https://www.cliqloan.com/" },
        { label: "TaxFlo", href: "https://taxflo.us/" },
      ],
    },
  ],
};

module.exports = navigation;
